import React from "react";
import PropTypes from "prop-types";

/**
 * Listen to scroll event and run the loadMore function when the bottom
 * is almost reached and the scroll stopped for a delay
 */

const LazyLoadContainer = (props) => {
  const { hasMore, loadMore, containerHeight } = props;
  const [timeoutRef, setTimeoutRef] = React.useState();

  const delay = 500;

  const handleScroll = () => {
    const container = document.getElementById("lazyLoadContainer");
    if (!timeoutRef && hasMore) {
      setTimeoutRef(
        setTimeout(() => {
          // Scroll reached 90% of the content's height
          if (
            container.scrollTop + container.offsetHeight >=
            container.scrollHeight * 0.9
          ) {
            loadMore();
          }
          setTimeoutRef(null);
        }, delay)
      );
    }
  };

  return (
    <div
      id={"lazyLoadContainer"}
      onScroll={handleScroll}
      style={{ height: containerHeight, overflow: "auto" }}
    >
      {props.children}
    </div>
  );
};

LazyLoadContainer.propTypes = {
  loadMore: PropTypes.func.isRequired,
  hasMore: PropTypes.bool.isRequired,
};

export default LazyLoadContainer;
